module.exports = __webpack_public_path__ + "static/img/minipg-backg-content.dc780174.png";